import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { formPrioritiesData } from '../../ui/meetingReview/helpers/formPrioritiesData'

export const getLongTermPriorities = (financialData: IELTFinancialData): string[] => {
  if (financialData.LongTermPriorities) {
    return formPrioritiesData(financialData.LongTermPriorities)
  }
  return []
}
